// AP: use this when we need to hide production features and we only want to test it inside the staging environment
// export const isProd = () => window.location.host === "app.projectric.com";
export const isProd = () => false;
